import {SvgIcon} from '@mui/material';
import React from 'react';
import {SvgIconComponent} from './types';

export const EmailIcon: SvgIconComponent = props => (
  <SvgIcon width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M15.5661 12.6142L20.3469 7.82845V16.6271L15.5661 12.6142ZM9.60921 13.7903L9.69434 13.8755C10.3101 14.4913 11.1292 14.831 12.0004 14.831C12.8708 14.831 13.6899 14.4913 14.3057 13.8755L14.3933 13.787L19.3426 17.9413H4.66066L9.60921 13.7903ZM8.43634 12.6166L3.6531 16.6304V7.8268L8.43634 12.6166ZM13.1369 12.7067C12.5294 13.3143 11.4698 13.3143 10.8647 12.7067L4.81853 6.6531H19.1856L13.1369 12.7067ZM4.47965 5C3.11005 5 2 6.11005 2 7.47965V17.1147C2 18.4851 3.11005 19.5944 4.47965 19.5944H19.5204C20.8899 19.5944 22 18.4851 22 17.1147V7.47965C22 6.11005 20.8899 5 19.5204 5H4.47965Z" />
  </SvgIcon>
);
